import { useEffect, useState } from "react";

export default function ProgressiveImage({
	src,
	placeholderSrc,
	loading,
	className,
}) {
	const [effectiveSrc, setEffectiveSrc] = useState(placeholderSrc);
	const [usedEffectStyle, setUsedEffectStyle] = useState({
		filter: "blur(5px)",
		clipPath: "inset(0)",
	});

	useEffect(() => {
		const img = new Image();
		img.src = src;
		img.onload = () => {
			setEffectiveSrc(img.src);
			setUsedEffectStyle({});
		};
	}, []);

	return (
		<img
			src={effectiveSrc}
			loading={loading}
			className={className}
			style={{ transition: "filter 0.1s ease-out", ...usedEffectStyle }}
		/>
	);
}
